/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Module, GetContentByIDV2Return } from '../../helpers/types'
import { Single, Stream } from './displays'
import { baseStyles } from './styles'

interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  getContentByIdV2?: () => Promise<GetContentByIDV2Return>
  index?: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isThreaded?: boolean
  modules: Module[]
  postType: string
  readOnly: boolean
  refreshedAt: string
  retweetUrl: string
  scheduledAt: string
  snapshotUrl: string
  timezone: string
  updateText: (val: string, destination: string) => void
}

const displays: { [key: string]: React.FC<any> } = {
  default: Single,
  desktopSingle: Single,
  mobileSingle: Single,
  desktopStream: Stream,
  mobileStream: Stream,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const TwitterRetweet: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display,
  getContentByIdV2,
  index = -1,
  isAccountPremium,
  isPresenting = false,
  isThreaded = false,
  modules = [],
  postType,
  readOnly = false,
  refreshedAt,
  retweetUrl,
  scheduledAt,
  snapshotUrl,
  timezone,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)
  const modulesLength = modules ? modules.length : 0

  return (
    <div
      css={baseStyles(display, postType)}
      className={kuiperClassNames(
        'twitter twitter-retweet',
        `twitter-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountUsername={accountUsername}
        accountName={accountName}
        content={content}
        display={display}
        isAccountPremium={isAccountPremium}
        isThreaded={isThreaded}
        index={index}
        modulesLength={modulesLength}
        scheduledAt={scheduledAt}
        refreshedAt={refreshedAt}
        retweetUrl={retweetUrl}
        snapshotUrl={snapshotUrl}
        timezone={timezone}
        isPresenting={isPresenting}
        readOnly={readOnly}
        getContentByIdV2={getContentByIdV2}
        onRefreshChange={(val: string) => updateText(val, 'refreshed_at')}
        onContentChange={(val: string) => updateText(val, 'content')}
        onRetweetUrlChange={(val: string) => updateText(val, 'retweet_url')}
        onSnapshotUrlChange={(val: string) => updateText(val, 'snapshot_url')}
      />
    </div>
  )
}
